import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldCheck } from 'lucide-react';

export default function ModerationSystem() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Moderation System</h1>
        <p className="text-[#8A93A6]">Content moderation, flagging, and community safety</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <ShieldCheck className="h-5 w-5 text-orange-500" />
            Moderation Queue
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Content moderation queue, flagged items, and community safety tools will be managed here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
